import React from 'react';
import PropTypes from 'prop-types';
import RippleButton from './RippleButton';
import { getFullUrl } from 'utils/utils';

const ShipOverview = ({ reasons, buttonCTAPath = '/ship', children }) => {
  return (
    <div className="bg-white text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col gap-11 lg:flex-row justify-between max-w-7xl mx-auto">
        <div className="w-full lg:w-2/5">
          {children}
          <br />
          {/* Book Now button */}
          <RippleButton
            onClick={() => { window.location.href = getFullUrl(buttonCTAPath, window.gon.subdomain); }}
            className="
              flex items-center justify-center bg-[#231F20] text-white rounded-full
              px-5 py-8 my-6 h-[48px] w-full md:w-3/4 lg:w-1/2 lg:max-w-72 text-lg mx-auto lg:mx-0
            "
          >
            Book Now
          </RippleButton>
        </div>

        <div className="w-full lg:w-3/5">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="
                flex items-start w-full mb-4 bg-gray-100 px-8 py-8
                border border-gray-300 rounded-3xl shadow-sm
              ">
              {/* <div className="text-[#4FAB55] font-bold text-3xl md:text-5xl flex-initial shrink-0 items-start w-1/12">
                {`0${index+1}`}
              </div> */}
              <div className="flex-grow h-auto flex flex-col text-left items-start justify-start">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  <div className="text-[#4FAB55] font-bold inline-block text-3xl pr-4 shrink-0">
                    {`0${index+1}`}
                  </div>
                  {reason.title}</h2>
                <p className="text-[18px] leading-[30px]">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ShipOverview.propTypes = {
  buttonCTAPath: PropTypes.string,
  children: PropTypes.node,
  reasons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};


export default ShipOverview;
